import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNoticeableIrritationEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16Zm0-30.5C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24 32 9.5 24 9.5Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M25.7 32.88c-.45 0-.74-.06-1-.12-.22-.05-.4-.09-.7-.09-.32 0-.48.04-.68.08-.23.06-.53.12-1.02.12-1.33 0-2.37-1.04-2.37-2.37 0-1.31 1.06-2.37 2.37-2.37.44 0 .73.06.98.12.22.05.4.09.73.09.3 0 .46-.04.66-.08.24-.06.54-.13 1.04-.13 1.31 0 2.37 1.06 2.37 2.37-.01 1.3-1.09 2.38-2.38 2.38ZM24 31.17c.47 0 .77.07 1.03.12.21.05.38.09.67.09.46 0 .87-.41.87-.87 0-.47-.4-.87-.87-.87-.33 0-.49.04-.7.09a3.8 3.8 0 0 1-1 .12c-.49 0-.81-.07-1.06-.13-.21-.05-.37-.08-.65-.08a.87.87 0 0 0-.87.87c0 .5.37.87.87.87.32 0 .48-.04.68-.08.24-.06.53-.13 1.03-.13Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16Zm0-30.5C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24 32 9.5 24 9.5Z",
    fill: "currentColor"
  }));
}

export { SvgNoticeableIrritationEmojiSecondary as default };
